<div class="d-flex" [ngClass]="selectedFiles.length > 0 ? 'files-in-selection-row' : ''">
    <div *ngIf="isSelectedFilesInfoVisible" class="ms-1 w-100">
        <div class="d-flex align-items-center selected-files-container" *ngIf="selectedFiles.length > 0">
            <div class="d-flex flex-column">
                <div class="selected-files d-flex justify-content-start align-items-center text-center">
                    <!-- Show success icon if there are valid selected files -->
                    <ca-icon
                        *ngIf="isMedCZIConversionDisabled ? selectedFiles.length > 0 : selectedFiles.length - invalidFilesNoDuplicates.length > 0"
                        name="checkmark"
                        size="m"
                        class="ca-color-success me-2"
                    ></ca-icon>
                    <!-- Display the number of valid files -->
                    <span data-uit="file-selection-selected-files-length">
                        {{ isMedCZIConversionDisabled ? selectedFiles.length : selectedFiles.length - invalidFilesNoDuplicates.length }} </span
                    >&nbsp;
                    <!-- Display appropriate label based on number of valid files -->
                    <span>
                        {{
                            isMedCZIConversionDisabled
                                ? selectedFiles.length === 1
                                    ? ('GENERAL.ADDED_FILE' | translate)
                                    : ('GENERAL.ADDED_FILES' | translate)
                                : selectedFiles.length - invalidFilesNoDuplicates.length === 1
                                  ? ('GENERAL.ADDED_FILE' | translate)
                                  : ('GENERAL.ADDED_FILES' | translate)
                        }}
                    </span>
                </div>
            </div>
        </div>
        <!-- Showing invalid files only -->
        <div
            *ngIf="
                invalidFiles.length > 0 &&
                !isMedCZIConversionDisabled &&
                numberOfConversionFailedFiles === 0 &&
                !isCziConversionInProgress &&
                !isValidationInProgress
            "
            class="d-flex align-items-center position-relative"
        >
            <ca-invalid-files-info
                [isSegmentation]="isSegmentation"
                *ngIf="invalidFiles?.length > 0 || unknownFiles.length > 0"
                [datasetId]="datasetId"
                [invalidFiles]="invalidFiles"
                [unknownFiles]="unknownFiles"
                (removeFiles)="onRemoveItems($event)"
            ></ca-invalid-files-info>
            <div class="w-50 position-relative" *ngIf="invalidFiles?.length > 0 || unknownFiles.length > 0">
                <button type="button" class="btn ca-btn-icon" (click)="reValidate()" [ngbTooltip]="'FILE_VALIDATION.REVALIDATE' | translate">
                    <ca-icon name="circle-arrow" [removeSVGAttributes]="['stroke']" size="s"></ca-icon>
                </button>
            </div>
        </div>
        <!-- Showing conversion files only -->
        <div *ngIf="numberOfConversionFailedFiles > 0 && !isMedCZIConversionDisabled" class="position-relative">
            <ca-czi-conversion-info
                [messagingCallbackAction]="retryMessagingAction"
                [isConversionInProgress]="isCziConversionInProgress"
                [isInvalidFilesNotificationVisible]="invalidFiles.length > 0"
                [files]="selectedFiles"
            ></ca-czi-conversion-info>
        </div>
    </div>
    <ca-upload-progress-container
        *ngIf="uploader?.queue.length > 0 || isCziConversionInProgress || isValidationInProgress"
        [uploader]="uploader"
        [initialValueOfFilesToBeUploaded]="initialValueOfFilesToBeUploaded$ | async"
        [initialUploaderQueueLength]="initialUploaderQueueLength"
        [numberOfCziFilesBeingConverted]="numberOfCziFilesBeingConverted"
        [numberOfFilesBeingValidated]="numberOfFilesBeingValidated"
        (cancelAllFileUploads)="onCancelAllFileUploads()"
        (cancelFileUpload)="onCancelFileUpload($event)"
    ></ca-upload-progress-container>
</div>
<ca-list-shell
    class="list-shell"
    [isCZIConversionInProgress]="isCziConversionInProgress"
    [isConversionFailedVisible]="numberOfConversionFailedFiles > 0"
    [isAddedFilesVisible]="numberOfSelectedFiles - invalidFiles.length > 0"
    [isUploadInProgress]="uploader?.queue.length !== 0"
    [isInvalidFilesVisibile]="invalidFiles.length > 0"
    [isResetButtonShown]="isResetButtonShown"
    [searchAndSortOptions]="currentSearchOptions"
    [totalItemsCount]="selectedFiles.length"
    [showCategoryButton]="false"
    [showFilterCheckBoxes]="false"
    [pageSize]="pageSize"
    [updateParameterQuery]="false"
    [useFirstSortOptionAsDefault]="false"
    (onTriggerSearchAndSort)="onFileSearchOrSort($event)"
    [isSearchInputShown]="false"
    (resetButtonClicked)="onRemoveItems({ items: selectedFiles, shouldConfirmDialogBeOpened: true })"
>
    <ca-files-table
        class="mt-2"
        [allFiles]="selectedFiles"
        [isCZIConversionInProgress]="isCziConversionInProgress"
        [isConversionFailedVisible]="numberOfConversionFailedFiles > 0"
        [isInvalidFilesVisibile]="invalidFiles.length > 0"
        [isFileExplorerShown]="isFileExplorerShown"
        [isSelectedFilesShown]="isSelectedFilesShown"
        [isUploadOfFilesEnabled]="isUploadOfFilesEnabled"
        [items]="pagedSelectedFiles"
        [isAddedFilesVisible]="numberOfSelectedFiles - invalidFiles.length > 0"
        [totalNumberOfFiles]="numberOfSelectedFiles"
        [allowSameFileNames]="false"
        [totalRowCount]="pagedSelectedFiles.length"
        [columns]="columns"
        [actions]="actions"
        [blobType]="blobType"
        [targetFolderToBeCreated]="targetFolderToBeCreated"
        [folderId]="currentFolderid"
        [myFilesClass]="true"
        [stickyHeader]="true"
        [showFileStatus]="showFileStatus"
        [uploaderKey]="uploaderKey"
        [cancelUpload]="cancelUpload"
        [cancelAllUploads]="cancelAllUploads"
        [supportedFileTypes]="supportedFileTypes"
        [truncateFileNameAtWidthOf]="200"
        [datasetId]="datasetId"
        [isSegmentation]="isSegmentation"
        [datasetFileType]="datasetFileType"
        (onUploadCancelled)="onUploadCancelled()"
        (onUploadCompleted)="onUploadCompleted($event)"
        (changeStudyId)="onChangeStudyID($event)"
        (changeCustomTags)="onChangeCustomTags($event)"
        (removeTag)="onTagRemoved($event)"
        (removeItems)="onRemoveItems($event)"
        (onFilesAdded)="onFilesAdded($event)"
        (targetFolderCreated)="targetFolderCreated.emit($event)"
        data-uit="selected-files-table"
    ></ca-files-table>
</ca-list-shell>
